import API from '@aws-amplify/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../../../i18n';
import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { ProtectedRouteContext } from '../../../Context';

import './Strikethrough.scss';

export default function Strikethrough(props) {
    const question = props.question;
    const shouldShowErrors = props.shouldShowErrors;
    const disabled = props.disabled;
    const appInstanceId = props.appInstanceId;
    const answerUpdated = props.answerUpdated;

    const [t] = useTranslation();
    const { userSettings } = useContext(ProtectedRouteContext);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );
    const [marked, setMarked] = useState(question.answerText === '1');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    const onValueChange = async () => {
        var newVal = !marked;
        setSaving(true);

        try {
            var updateAnswerResponse = await API.put('ShipyardAPI', `/application/${appInstanceId}/answer/${question.id}`, {
                body: { responseText: newVal ? '1' : '0' },
            });
        } catch (apiErr) {
            toast.error(t('General.AjaxError'));
            return;
        }

        if (!updateAnswerResponse.success) {
            toast.error(t('General.AjaxError'));
            return;
        }

        setSaving(false);
        question.answerText = newVal ? '1' : '0';
        setMarked(newVal);
        var validity = question.validator(question);
        question.isValid = validity.isValid;
        question.invalidReason = validity.invalidReason;
        answerUpdated();
    };

    return (
        <div
            className={
                'question-wrapper strikethrough' +
                (!question.isValid && shouldShowErrors ? ' invalid' : '') +
                (marked ? ' marked' : '') +
                (saving ? ' saving' : '') +
                (disabled ? ' disabled' : '')
            }
        >
            {saving ? (
                <div className="saving">
                    <FontAwesomeIcon icon={faSpinner} />
                </div>
            ) : null}
            <input
                type="checkbox"
                id={`quest-${question.id}-strike`}
                value="1"
                checked={marked}
                disabled={saving}
                onChange={onValueChange}
            />
            <label htmlFor={`quest-${question.id}-strike`}>
                <ReactMarkdown
                    children={question.text[lang]}
                    linkTarget="_blank"
                />
            </label>
        </div>
    );
}
